// extracted by mini-css-extract-plugin
export var centeredText = "Layout-module--centeredText--da9e4";